import { render } from "./PageTopPNInfo.vue?vue&type=template&id=3b35606a&scoped=true&ts=true"
import script from "./PageTopPNInfo.vue?vue&type=script&lang=ts"
export * from "./PageTopPNInfo.vue?vue&type=script&lang=ts"

import "./PageTopPNInfo.vue?vue&type=style&index=0&id=3b35606a&scoped=true&lang=css"

import exportComponent from "D:\\project\\CDM_QR-Access-Control-System-3\\DoorWebApp_Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b35606a"]])

export default __exports__